module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya/access/sakae_point3_3-5219a82749355f1a39fad0868870c42e.jpg";